import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FormField from './FormField';

class StaticField extends PureComponent {
  render() {
    const {label, value} = this.props;
    return <FormField inputClass="form-control-static" label={label}>{value}</FormField>
  }
};

export default StaticField;